import { API } from "../../../api/constants"
import { sessionCheckClient } from "../../../auth/AuthenticatedAxios"

// öffentliche Endpunkte (ohne Anmeldung): Farbe und Logo für die Login-Seite
export const getLoginColorAndLogo = (): Promise<{ color?: string; logo?: { s3Key?: string } }> => sessionCheckClient.get(API + "/global-settings/color-and-logo").then((res) => res.data)

export const getLoginLogo = async () => {
    const response = await sessionCheckClient.get(API + "/global-settings/logo", { responseType: "blob" })
    return URL.createObjectURL(response.data)
}
